import React from 'react';
import BlogCard from './BlogCard';
import Container from './Container';

const BlogSection = () => {
  // Blog data array - easily replaceable with API data
  const blogs = [
    {
      id: 1,
      title: 'ELDRdigrey.com Secure Digital Personal Medical Storage',
      image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=400&h=300&fit=crop',
      link: '#blog1'
    },
    {
      id: 2,
      title: 'ELDR provides a secure home for those valuable Estate Planning documents',
      image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=400&h=300&fit=crop',
      link: '#blog2'
    },
    {
      id: 3,
      title: 'ELDR is working with Businesses to provide HR Non-Traditional Employee Benefits',
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop',
      link: '#blog3'
    },
    {
      id: 4,
      title: 'ELDR is working with Businesses to build complimentary relationships',
      image: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=400&h=300&fit=crop',
      link: '#blog4'
    },
    {
      id: 5,
      title: 'ELDR is working with Companies that Serve Hospitals and Doctors',
      image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=400&h=300&fit=crop',
      link: '#blog5'
    },
    {
      id: 6,
      title: 'ELDR is working with the US State Department to Support Foreign Travel needs',
      image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=400&h=300&fit=crop',
      link: '#blog6'
    },
    {
      id: 7,
      title: 'ELDR is working with the Military and other Security agencies to support regulations & support',
      image: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=400&h=300&fit=crop',
      link: '#blog7'
    },
    {
      id: 8,
      title: 'ELDR is working to provide the highest level of privacy and security and provide peace of mind to our customers',
      image: 'https://images.unsplash.com/photo-1505751172876-fa1923c5c528?w=400&h=300&fit=crop',
      link: '#blog8'
    }
  ];

  return (
    <section className="blog-section" id="blog">
            <Container>

      <div className="blog-container">
        <div className="blog-grid">
          {blogs.map((blog) => (
            <BlogCard 
            key={blog.id}
            image={blog.image}
            title={blog.title}
            link={blog.link}
            />
          ))}
        </div>
      </div>
          </Container>
    </section>
  );
};

export default BlogSection;
